import axios, { AxiosError, AxiosRequestConfig } from "axios";

// Сессия живёт в HttpOnly-cookie hawk.sid, токены подставляет сам сервер.
// Куку нужно слать на каждом запросе к API; часть компонентов ходит напрямую
// через глобальный axios, поэтому дефолт ставим и на нём.
axios.defaults.withCredentials = true;

const axiosInstance = axios.create({
    baseURL: "/api",
    withCredentials: true,
});

// На этих запросах 401 — штатный ответ ("сессии нет" / "неверный пароль"),
// а не сигнал о протухшей сессии, поэтому редиректить с них нельзя.
const AUTH_PROBE = /\/auth\/(login|me|register)(\?|$)/;

function isAuthProbe(config?: AxiosRequestConfig): boolean {
    if (!config) return false;

    return AUTH_PROBE.test(`${config.baseURL ?? ""}${config.url ?? ""}`);
}

// 401 теперь означает "сессии нет": она могла истечь по политике Keycloak,
// быть отозванной администратором или закрытой из другой вкладки.
function onUnauthorized(error: AxiosError): Promise<never> {
    if (
        error.response?.status === 401 &&
        !isAuthProbe(error.config) &&
        window.location.pathname !== "/login"
    ) {
        window.location.href = "/login?session=expired";
    }

    return Promise.reject(error);
}

axiosInstance.interceptors.response.use((response) => response, onUnauthorized);
axios.interceptors.response.use((response) => response, onUnauthorized);

export default axiosInstance;
